import { AutogenLayoutCarrierSelectionExpand } from "./autogen/AutogenLayoutCarrierSelectionExpand";

export class CarrierSelectionExpand extends AutogenLayoutCarrierSelectionExpand {
}
